import '../Client/AO/Alertes.scss';

import { Clear } from '@mui/icons-material';
import { Button, IconButton} from '@mui/material';
import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';

import DialogCreatealerte from '../../Components/Dialogs/DialogCreatealerte';
import {buttonStylesGreen } from '../../Components/docsAdministrative/JsObjectStyles';
import { modeTravailEnum, regimeTravailEnum } from '../../data/Interfaces';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useGetRequest from '../../hooks/useGetRequest';
import useWindowSize from '../../hooks/useWindowSize';
import { formatDateJJMMYYYY } from '../../Utils/dateFormatter';
import { searchLabelInEnumByValue } from '../../Utils/utils';

function Alertes() {
    const axiosPrivate= useAxiosPrivate();
    const {data: alerts , refresh: refreshAlerts} = useGetRequest({url: '/expert/getMyAlerts'});
    const [open,setOpen]=useState(false);
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    const deleteAlert = async (alertId) => {
        const response = await axiosPrivate.delete(`/expert/deleteAlert/${alertId}`);
        if (response) {
            refreshAlerts();
        }
    };
    return (
        <>
            <div style={{width:'100%',display:'flex',flexDirection:'column',gap:'24px'}}>
                <>
                    <div className='frame5Profile'>{i18n.t('Appels d\'offres')} &gt; <span style={{color:'rgba(39, 45, 60, 1)'}}>  {i18n.t('Mes alertes')}</span> </div><div className='divtitlealerte'>
                        <h4 className='titlesociete'>{i18n.t('Mes alertes')}</h4>
                    </div>
                    <div
                        className='allinone'
                        style={{alignItems:(Array.isArray(alerts) && alerts.length < 1)?'center':'end'}}
                    >
                        {(Array.isArray(alerts) && alerts.length < 1) &&
                        <>
                            <img
                                src="/img_card/alertesicon.png"
                                className='imgstyle'
                            />
                            <div className='alerterecherchetxt'>
                                <h4 className='titlesociete'>{i18n.t('Vous trouverez ici vos alertes de recherche')}</h4>
                                <p className='Secondtxt'>{i18n.t('Vous pouvez définir votre alerte de recherche')}</p>
                            </div>
                        </>
                        }
                        <Button
                            onClick={() => {
                                setOpen(true);
                            }}
                            style={{...buttonStylesGreen(), ...{width:device=='desktop'?'auto':'100%'}}}
                        >
                            {i18n.t('Créer une alerte')}
                        </Button>
                    </div>
                </>
                {/* // ! @ aida: see lahsen what meant by this composante, search about it...  (lahsen only know hhhh) */}
                {/*<AlertesAdded/>*/}
                {Array.isArray(alerts) && alerts.map((alert, i) => (

                    <div
                        className='rectoffer'
                        key={i}
                    >
                        <div className='rectoffer1'>
                            <div className='rectoffer11'>
                                <div className='rectoffer111'>
                                    <h6 className='firsttxtoffer'>{alert?.intitulePoste} {alert?.localisation && 'à ' + alert?.localisation}</h6>
                                    <b className='secondtxtoffer'>{i18n.t('Mots clés:')} {alert?.keywords}</b>
                                    <b className='secondtxtoffer'>{i18n.t(searchLabelInEnumByValue(modeTravailEnum,alert.modeTravail?.type))} - {i18n.t(searchLabelInEnumByValue(regimeTravailEnum,alert.regimeTravail?.type))}</b>
                                </div>
                            </div>
                            <div className='rectoffer12'>
                                <p className='dateoffer'>{i18n.t('Créé le')} {formatDateJJMMYYYY(alert?.createdAt)}
                                </p>
                                <IconButton
                                    onClick={() => {
                                        deleteAlert(alert._id);
                                    }}
                                >
                                    <Clear />
                                </IconButton>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            {open &&
                <DialogCreatealerte
                    open={open}
                    onClose={()=>{
                        setOpen(false);
                        refreshAlerts();
                    }}
                />
            }
        </>
    );
}

export default Alertes;